// src/components/common/Icon.tsx
import React from 'react';

interface IconProps {
  icon: any; // TypeScript hatalarını önlemek için any kullanıyoruz
  size?: number | string;
  color?: string;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ icon: IconComponent, ...props }) => {
  return React.createElement(IconComponent, props);
};
